// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
  /** The spec marks this field readOnly, so no request body may carry it. */
  readOnly?: boolean
}

export const usersResponseSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
    readOnly: true,
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
    readOnly: true,
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
    readOnly: true,
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
    readOnly: true,
  },
  {
    key: 'companyId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'companyId',
    readOnly: true,
  },
  {
    key: 'externalId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'externalId',
  },
  {
    key: 'status',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'status',
    options: ['inactive', 'active'],
  },
  {
    key: 'type',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'type',
    options: ['borrower', 'agent', 'service'],
  },
  {
    key: 'roleIds',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'roleIds',
    nested: [
      {
        key: '0',
        type: 'string',
        required: true,
        component: 'TextInput',
        fullPath: 'roleIds[0]',
      },
    ],
  },
  {
    key: 'object',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'object',
    options: ['user'],
    readOnly: true,
  },
  {
    key: 'userId',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'userId',
    numberFormat: 'integer',
  },
  {
    key: 'userName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'userName',
    readOnly: true,
  },
  {
    key: 'auths',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'auths',
    nested: [
      {
        key: '0',
        type: 'object',
        required: true,
        component: 'TextInput',
        fullPath: 'auths[0]',
        nested: [
          {
            key: 'authType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'auths[0].authType',
            options: [
              'basic',
              'google',
              'oneTimeCodeEmail',
              'oneTimeCodeText',
              'SAML',
            ],
          },
          {
            key: 'authValueType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'auths[0].authValueType',
            options: ['email', 'username', 'phone', 'samlSubjectNameId'],
          },
          {
            key: 'value',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'auths[0].value',
          },
        ],
        readOnly: true,
      },
    ],
    readOnly: true,
  },
  {
    key: 'employee',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'employee',
    nested: [
      {
        key: 'id',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'employee.id',
      },
      {
        key: 'createdAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'employee.createdAt',
      },
      {
        key: 'updatedAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'employee.updatedAt',
      },
      {
        key: 'deletedAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'employee.deletedAt',
      },
      {
        key: 'firstName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'employee.firstName',
      },
      {
        key: 'lastName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'employee.lastName',
      },
    ],
    readOnly: true,
  },
  {
    key: 'person',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'person',
    nested: [
      {
        key: 'id',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.id',
      },
      {
        key: 'createdAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.createdAt',
      },
      {
        key: 'updatedAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.updatedAt',
      },
      {
        key: 'deletedAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.deletedAt',
      },
      {
        key: 'borrowerType',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'person.borrowerType',
        options: ['business', 'person'],
      },
      {
        key: 'externalId',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.externalId',
      },
      {
        key: 'status',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'person.status',
        options: ['inactive', 'active'],
      },
      {
        key: 'statusUpdatedAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.statusUpdatedAt',
      },
      {
        key: 'collectionsIntensity',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'person.collectionsIntensity',
        options: ['normal', 'light', 'heavy'],
      },
      {
        key: 'displayId',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.displayId',
      },
      {
        key: 'metaData',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'person.metaData',
        nested: [],
      },
      {
        key: 'commPreferences',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'person.commPreferences',
        nested: [
          {
            key: 'statementDeliveryChannels',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'person.commPreferences.statementDeliveryChannels',
            nested: [
              {
                key: '0',
                type: 'enum',
                required: true,
                component: 'Select',
                fullPath: 'person.commPreferences.statementDeliveryChannels[0]',
                options: ['email', 'mail'],
              },
            ],
          },
          {
            key: 'sendRemindersWhenCurrent',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'person.commPreferences.sendRemindersWhenCurrent',
          },
        ],
      },
      {
        key: 'monitorStartDate',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.monitorStartDate',
      },
      {
        key: 'companyId',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.companyId',
      },
      {
        key: 'user',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'person.user',
        nested: [
          {
            key: 'id',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.user.id',
          },
          {
            key: 'createdAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.user.createdAt',
          },
          {
            key: 'updatedAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.user.updatedAt',
          },
          {
            key: 'deletedAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.user.deletedAt',
          },
          {
            key: 'companyId',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.user.companyId',
          },
          {
            key: 'externalId',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.user.externalId',
          },
          {
            key: 'status',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'person.user.status',
            options: ['inactive', 'active'],
          },
          {
            key: 'type',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'person.user.type',
            options: ['borrower', 'agent', 'service'],
          },
          {
            key: 'roleIds',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'person.user.roleIds',
            nested: [
              {
                key: '0',
                type: 'string',
                required: true,
                component: 'TextInput',
                fullPath: 'person.user.roleIds[0]',
              },
            ],
          },
          {
            key: 'userId',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'person.user.userId',
            numberFormat: 'integer',
          },
          {
            key: 'userName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.user.userName',
          },
          {
            key: 'auths',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'person.user.auths',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'person.user.auths[0]',
                nested: [
                  {
                    key: 'authType',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'person.user.auths[0].authType',
                    options: [
                      'basic',
                      'google',
                      'oneTimeCodeEmail',
                      'oneTimeCodeText',
                      'SAML',
                    ],
                  },
                  {
                    key: 'authValueType',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'person.user.auths[0].authValueType',
                    options: [
                      'email',
                      'username',
                      'phone',
                      'samlSubjectNameId',
                    ],
                  },
                  {
                    key: 'value',
                    type: 'string',
                    required: false,
                    component: 'TextInput',
                    fullPath: 'person.user.auths[0].value',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'name',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'person.name',
        nested: [
          {
            key: 'id',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.id',
          },
          {
            key: 'createdAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.createdAt',
          },
          {
            key: 'updatedAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.updatedAt',
          },
          {
            key: 'deletedAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.deletedAt',
          },
          {
            key: 'prefix',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.prefix',
          },
          {
            key: 'firstName',
            type: 'string',
            required: true,
            component: 'TextInput',
            fullPath: 'person.name.firstName',
          },
          {
            key: 'middleName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.middleName',
          },
          {
            key: 'lastName',
            type: 'string',
            required: true,
            component: 'TextInput',
            fullPath: 'person.name.lastName',
          },
          {
            key: 'maidenLastName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.maidenLastName',
          },
          {
            key: 'suffix',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.suffix',
          },
          {
            key: 'preferredFirstName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.preferredFirstName',
          },
          {
            key: 'current',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'person.name.current',
          },
          {
            key: 'status',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'person.name.status',
            options: ['inactive', 'active'],
          },
          {
            key: 'effectiveAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.effectiveAt',
          },
          {
            key: 'originalValue',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'person.name.originalValue',
            nested: [],
          },
          {
            key: 'source',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'person.name.source',
            options: ['peach', 'lender', 'externalAPI'],
          },
        ],
      },
      {
        key: 'dateOfBirth',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'person.dateOfBirth',
      },
      {
        key: 'identity',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'person.identity',
        nested: [
          {
            key: 'id',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.id',
          },
          {
            key: 'createdAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.createdAt',
          },
          {
            key: 'updatedAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.updatedAt',
          },
          {
            key: 'deletedAt',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.deletedAt',
          },
          {
            key: 'identityType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'person.identity.identityType',
            options: [
              'SSN',
              'ITIN',
              'passport',
              'driversLicense',
              'taxID',
              'FEIN',
              'stateID',
              'customID',
            ],
          },
          {
            key: 'customIdentityTypeName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.customIdentityTypeName',
          },
          {
            key: 'value',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.value',
          },
          {
            key: 'valid',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'person.identity.valid',
          },
          {
            key: 'issueDate',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.issueDate',
          },
          {
            key: 'expirationDate',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.expirationDate',
          },
          {
            key: 'issuingCountry',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'person.identity.issuingCountry',
          },
        ],
      },
      {
        key: 'identities',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'person.identities',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'person.identities[0]',
            nested: [
              {
                key: 'isArchived',
                type: 'boolean',
                required: false,
                component: 'Checkbox',
                fullPath: 'person.identities[0].isArchived',
              },
              {
                key: 'id',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].id',
              },
              {
                key: 'createdAt',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].createdAt',
              },
              {
                key: 'updatedAt',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].updatedAt',
              },
              {
                key: 'deletedAt',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].deletedAt',
              },
              {
                key: 'identityType',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'person.identities[0].identityType',
                options: [
                  'SSN',
                  'ITIN',
                  'passport',
                  'driversLicense',
                  'taxID',
                  'FEIN',
                  'stateID',
                  'customID',
                ],
              },
              {
                key: 'customIdentityTypeName',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].customIdentityTypeName',
              },
              {
                key: 'value',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].value',
              },
              {
                key: 'valid',
                type: 'boolean',
                required: false,
                component: 'Checkbox',
                fullPath: 'person.identities[0].valid',
              },
              {
                key: 'issueDate',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].issueDate',
              },
              {
                key: 'expirationDate',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].expirationDate',
              },
              {
                key: 'issuingCountry',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'person.identities[0].issuingCountry',
              },
              {
                key: 'isPrimary',
                type: 'boolean',
                required: false,
                component: 'Checkbox',
                fullPath: 'person.identities[0].isPrimary',
              },
            ],
          },
        ],
      },
    ],
    readOnly: true,
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(usersResponseSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(usersResponseSchema)
}
